module.exports = __webpack_public_path__ + "static/img-mob-dev-6a2f1a0f3045d9c05463e7525dd1fbaa.png";